export default __webpack_public_path__ + "static/media/1.3e62abd8.png";